import { Tabs as AntdTabs } from "antd"

const Tab = props => {
  return <AntdTabs {...props}></AntdTabs>
}

export default Tab
